import { Component, Input } from '@angular/core';
import { HeroCardConfig } from './hero-card-config.interface';

@Component({
  selector: 'hero-card',
  standalone: false,
  templateUrl: './hero-card.component.html',
  styleUrls: ['./hero-card.component.scss'],
})
export class HeroCardComponent {
  @Input() config!: HeroCardConfig;
}
